<div
  #progressBar
  class="progress-bar"
  [style.width]="displayedPercentageProgress + '%'"
>
</div>

<p class="percentage-text sm-text-black">
  {{ displayedPercentageProgress }}%
</p>

<p
  class="percentage-text percentage-text-top sm-text-white"
  #percentageTextTop
>
  {{ displayedPercentageProgress }}%
</p>
